import { useLayoutState } from 'components/shared/Layout';
import { useState, useEffect } from 'react';
import useSiteSlug from 'common/hooks/useSiteSlug';
import { i18n } from 'config/i18n';

export const tours = {
  id: 'tours',
  name: 'layout:common.tours',
  submenu: [
    {
      text: 'layout:common.motorcycle_tours',
      href: '/motorcycle-tours',
    },
    {
      text: 'layout:common.guided_motorcycle_tours',
      href: '/guided-motorcycle-tours',
    },
    {
      text: 'layout:common.self_motorcycle_tours',
      href: '/self-drive-motorcycle-tours',
    },
    {
      text: 'layout:common.popular_motorcycle_trips',
      href: '/motorcycle-trips',
    },
  ],
};

export const information = {
  id: 'information',
  name: 'eaglerider_information:header',
  submenu: [
    {
      text: 'eaglerider_information:contact_us',
      href: '/eagleshare-support',
    },
    {
      text: 'fe_eaglerider_information:site_map',
      href: '/siteindex',
    },

    {
      text: 'eaglerider_information:insurance',
      href: '/information',
    },
    {
      text: 'eaglerider_information:driver_license_requirements',
      href: '/information',
    },
    {
      text: 'eaglerider_information:privacy_policy',
      href: '/information',
    },
    {
      text: 'eaglerider_information:faqs',
      href: '/information',
    },
    {
      text: 'eaglerider_information:terms_and_conditions',
      href: '/information',
    },
    {
      text: 'eaglerider_information:more_info',
      href: '/information',
    },
  ],
};

/** *
 * Custom hook instead of static arrays because we have data that is fetched dynamically
 * from the API and to separate this logic from the components
 ** */

const useFooterSitemap = () => {
  const { layoutState } = useLayoutState();
  const { structureURL } = useSiteSlug();
  const [rentals, setRentals] = useState({
    id: 'rentals',
    name: 'layout:common.rentals',
    isOpen: false,
  });
  const [featured_geographies, setFeaturedGeographies] = useState({
    id: 'featured_geographies',
    name: 'layout:common.top_cities',
    isOpen: false,
  });

  const [categories, setCategories] = useState([]);

  useEffect(() => {
    // populate rentals
    if (
      layoutState?.featured_rentals
      && layoutState.featured_rentals.footer
    ) {
      const rentals_submenu = layoutState.featured_rentals.footer.map(
        (rental) => ({
          text: rental.is_harley_davidson
            ? 'layout:footer.harley_rentals'
            : `rentals:${rental.translation_key}_rentals`,
          href: structureURL(rental.slug, layoutState.current_language.code),
          is_harley_davidson: rental.is_harley_davidson,
          dataRoute: true,
        }),
      );
      setRentals({
        ...rentals,
        submenu: [...rentals_submenu],
      });
    }

    if (layoutState?.featured_geographies) {
      setFeaturedGeographies({
        ...featured_geographies,
        submenu: [
          ...layoutState.featured_geographies.map((geography) => ({
            text: geography.region.code ? `${geography.name}, ${geography.region.code}`
              : geography.region.name ? `${geography.name}, ${geography.region.name}`
                : `${geography.name}, ${geography.country.name}`,
            href: structureURL(`${i18n.t('routes:motorcycle-rental')}/${geography.slug}`, layoutState.current_language.code),
          })),
        ],
      });
    }
  }, [layoutState]);

  useEffect(() => {
    setCategories([
      { ...rentals },
      { ...featured_geographies },
      { ...information },
    ]);
  }, [rentals]);

  return categories;
};

export default useFooterSitemap;
